import React, { useMemo } from 'react';

import ZoneSectionTableField from './ZoneSectionTableField';

const TopEtab = ({
  zones = [],
  ...rest
}) => {
  const zonesWithTopEtab = useMemo(() => zones.map(
    zone => {
      try {
        const top = zone.etablissements
          .map(etablissement => ({ ...etablissement, tefet_id: +etablissement.tefet_id }))
          .sort((a, b) => b.tefet_id - a.tefet_id)
          .slice(0, 5);

        return { ...zone, top };
      } catch (err) {
        return { ...zone, top: [] };
      }
    },
  ), [zones]);

  return (
    <ZoneSectionTableField
      field="top"
      sortFromFirst={false}
      zones={zonesWithTopEtab}
      {...rest}
    />
  );
};

export default TopEtab;
